<template>
	<div>
		<metrics-facade
			:metrics="data.metrics"
			:compare="data.compare"
			:details="data.details"
			:samples="data.samples"></metrics-facade>
		<compare-facade :data="data.compare_samples" :sample-size="7" class="mt-5"></compare-facade>
		<breakdown-facade :data="data.breakdown" showFilledJobValue class="mt-5"></breakdown-facade>
	</div>
</template>
<script>
	import { ref, onMounted, inject, watch, nextTick } from "vue";
	import metricsFacade from "./metricsFacade.vue";
	import compareFacade from "./compareFacade.vue";
	import breakdownFacade from "./breakdownFacade.vue";
	export default {
		components: {
			metricsFacade,
			compareFacade,
			breakdownFacade
		},
		props: {
			data: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		setup(props, context) {
			return {};
		}
	};
</script>